import { useState } from "react";
import { Expand } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

export const Exhibit = ({ shot, plate, aspect = "aspect-[16/10]", className = "", eager = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <figure className={`exhibit group ${className}`} data-testid={`exhibit-${shot.id}`}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`relative block w-full overflow-hidden border border-slate-200 bg-white ${aspect}`}
        aria-label={`Enlarge screenshot: ${shot.title}`}
        data-testid={`exhibit-open-${shot.id}`}
      >
        <img
          src={shot.img}
          alt={`Grace Treasury: ${shot.title}`}
          loading={eager ? "eager" : "lazy"}
          className={`h-full w-full object-cover object-top ${shot.tall ? "exhibit-pan" : ""}`}
        />
        <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-navy/85 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <Expand className="h-3.5 w-3.5" />
        </span>
      </button>
      <figcaption className="mt-3 flex items-baseline justify-between gap-4 px-1">
        <span className="eyebrow">Plate {plate}</span>
        <span className="text-xs text-slate-600">{shot.label}</span>
      </figcaption>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] w-[94vw] max-w-6xl overflow-y-auto p-3 sm:p-4" data-lenis-prevent data-testid={`exhibit-dialog-${shot.id}`}>
          <DialogTitle className="sr-only">{shot.title}</DialogTitle>
          <DialogDescription className="sr-only">{shot.body}</DialogDescription>
          <img src={shot.img} alt={`Grace Treasury: ${shot.title}`} className="w-full border border-slate-200" />
        </DialogContent>
      </Dialog>
    </figure>
  );
};
